"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsButton = exports.CommonControlsText = exports.Dialog = exports.TextboxStateWrapper = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.FieldsetGroup = exports.ApplyWithButtons = exports.CommonControlsSectionHeader = exports.LayoutControlsPanel = exports.ApplicationContactInfo = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var ApplyWithButtons_1 = require("../ApplyWithButtons/ApplyWithButtons");
Object.defineProperty(exports, "ApplyWithButtons", { enumerable: true, get: function () { return ApplyWithButtons_1.ApplyWithButtons; } });
var FieldsetGroup_1 = require("../FieldsetGroup/FieldsetGroup");
Object.defineProperty(exports, "FieldsetGroup", { enumerable: true, get: function () { return FieldsetGroup_1.FieldsetGroup; } });
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var TextboxStateWrapper_1 = require("../TextboxStateWrapper/TextboxStateWrapper");
Object.defineProperty(exports, "TextboxStateWrapper", { enumerable: true, get: function () { return TextboxStateWrapper_1.TextboxStateWrapper; } });
var Dialog_1 = require("../Dialog/Dialog");
Object.defineProperty(exports, "Dialog", { enumerable: true, get: function () { return Dialog_1.Dialog; } });
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var Button_1 = require("player-common-controls/controls/Button");
Object.defineProperty(exports, "CommonControlsButton", { enumerable: true, get: function () { return Button_1.Button; } });
var ApplicationContactInfo = (function (_super) {
    __extends(ApplicationContactInfo, _super);
    function ApplicationContactInfo(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationContactInfo.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationContactInfo.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationContactInfo.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationContactInfo.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationContactInfo.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationContactInfo.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationContactInfo.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationContactInfo.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationContactInfo.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Small", children: [React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: $this.state.viewModel.sectionTitle })] }), React.createElement(PlayerVisible, { key: 1, visible: $this.state.viewModel.showApplyWithButtons, children: [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Medium", children: [React.createElement(ApplyWithButtons_1.ApplyWithButtons, { key: 0, services: $this.state.viewModel.actionItem.services, errorMessage: $this.state.viewModel.applyWithErrorMessage, applyWithButtonLabel: $this.state.viewModel.applyWithButtonLabel, onClick: _this._proxyEvent("onApplyWithButtonClicked") })] })] }), React.createElement(FieldsetGroup_1.FieldsetGroup, { key: 2, legend: $this.state.viewModel.sectionTitle, children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Medium", gutterVertical: "Small", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "6", children: [React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, errorMessage: $this.state.viewModel.actionItem.firstName.errorMessage, isRequired: $this.state.viewModel.actionItem.firstName.isRequired, label: $this.state.viewModel.firstNameLabel, value: $this.state.viewModel.actionItem.firstName.value, isEnabled: $this.state.viewModel.isContactInfoFieldEnabled, id: "actionItem.firstName.idTag", tag: "actionItem.firstName.idTag", maxLength: 200, ariaLabeledBy: "actionItem.firstName.idTag-error", onChange: _this._proxyEvent("onFirstNameChange"), onBlur: _this._proxyEvent("onContactInfoUpdated") })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "12", widthForSm: "6", children: [React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, errorMessage: $this.state.viewModel.actionItem.lastName.errorMessage, isRequired: $this.state.viewModel.actionItem.lastName.isRequired, label: $this.state.viewModel.lastNameLabel, value: $this.state.viewModel.actionItem.lastName.value, isEnabled: $this.state.viewModel.isContactInfoFieldEnabled, id: "actionItem.lastName.idTag", tag: "actionItem.lastName.idTag", maxLength: 200, ariaLabeledBy: "actionItem.lastName.idTag-error", onChange: _this._proxyEvent("onLastNameChange"), onBlur: _this._proxyEvent("onContactInfoUpdated") })] }), React.createElement(GridCol_1.GridCol, { key: 2, width: "12", widthForSm: "6", children: [React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, errorMessage: $this.state.viewModel.actionItem.email.errorMessage, isRequired: $this.state.viewModel.actionItem.email.isRequired, label: $this.state.viewModel.emailLabel, value: $this.state.viewModel.actionItem.email.value, isEnabled: $this.state.viewModel.isContactInfoFieldEnabled, type: "Email", id: "actionItem.email.idTag", tag: "actionItem.email.idTag", maxLength: 120, ariaLabeledBy: "actionItem.email.idTag-error", autoComplete: "email", onChange: _this._proxyEvent("onEmailChange"), onBlur: _this._proxyEvent("onEmailValidate") })] })] })] }), React.createElement(Dialog_1.Dialog, { key: 3, isVisible: $this.state.viewModel.isLoginDialogVisible, id: "contactLoginDialog", tag: "contactLoginDialog", title: $this.state.viewModel.loginDialogTitle, useCustomFooter: true, usePortal: true, children: [React.createElement(Panel_1.Panel, { key: 0, horizontalAlign: "Center", children: [React.createElement(Text_1.Text, { key: 0, color: "Muted", mode: "Paragraph", size: "Large", tag: "loginDialogText", text: $this.state.viewModel.dialogText })] })], footer: [React.createElement(Panel_1.Panel, { key: 0, paddingAll: "Medium", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Small", gutterVertical: "Xsmall", columnDirectionForSm: "RowReverse", colMainAxisAlignmentForSm: "SpaceBetween", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "Auto", children: [React.createElement(Button_1.Button, { key: 0, color: "Primary", tag: "loginDialogLoginBtn", text: $this.state.viewModel.signInButtonLabel, width: "Block", onClick: _this._proxyEvent("onSignInClick") })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "12", widthForSm: "Auto", children: [React.createElement(PlayerVisible, { key: 0, visible: $this.state.viewModel.isCancelBtnVisible, children: [React.createElement(Button_1.Button, { key: 0, color: "Grey", tag: "loginDialogCancelBtn", text: $this.state.viewModel.cancelButtonLabel, width: "Block", onClick: _this._proxyEvent("onDialogClose") })] })] })] })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applicationcontactinfo" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationContactInfo.defaultProps = {
        actionItem: "", reqId: "", careerSiteId: "", displayApplyWithErrorMessage: "", sectionTitle: "", firstNameLabel: "", lastNameLabel: "", emailLabel: "", loginDialogTitle: "", signInButtonLabel: "", cancelButtonLabel: "", genericErrorMessage: "", applyWithAlreadyAssociated: "", applyWithExistingUser: "", applyWithGenericError: "", applyWithAuthenticationError: "", applyWithInactiveUserError: "", applyWithButtonLabel: "", applicationId: "",
        onDataChanged: function () { }, onFirstNameChange: function () { }, onLastNameChange: function () { }, onEmailChange: function () { }, onActionLoaded: function () { }, onLoadingChanged: function () { }
    };
    return ApplicationContactInfo;
}(React.Component));
exports.ApplicationContactInfo = ApplicationContactInfo;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationContactInfo"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationContactInfo/ApplicationContactInfo.js
// module id = 582
// module chunks = 0